import React, { HTMLInputTypeAttribute } from 'react';

import FormTextError from '@/components/formTextError/formTextError';

import styles from './styles.module.css';

const TextInput: React.FC<TextInputProps> = ({
  label,
  labelFor,
  placeholder,
  type,
  value,
  icon,
  img,
  textError,
  isError,
  required,
  onChange,
  onKeyDown,
  onClickIcon,
  onFocusInput,
}) => {
  return (
    <div>
      <div className={styles.textInputTopLabel}>
        <label htmlFor={labelFor}>{label}</label>
      </div>

      <div className={styles.textInputMontantVersement}>
        <input
          className={`${styles.faireVersementInput} ${isError ? styles.textInputInputError : ''}`}
          id={labelFor}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown}
          required={required}
          onFocus={onFocusInput}
        />
        {img && (
          <span className={isError ? styles.textInputIconError : ''}>
            <i className={img} />
          </span>
        )}

        {icon && (
          <span
            className={styles.textInputIcon}
            role={onClickIcon ? 'button' : undefined}
            tabIndex={onClickIcon ? 0 : undefined}
            onClick={onClickIcon}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (onClickIcon) onClickIcon();
              }
            }}
          >
            <i className={icon} />
          </span>
        )}
      </div>

      {textError && isError && (
        <div>
          <FormTextError text={textError} />
        </div>
      )}
    </div>
  );
};

export interface TextInputProps {
  label: string;
  labelFor: string;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  value?: string | number;
  icon?: string;
  img?: string;
  textError?: string | null;
  isError?: boolean;
  required?: boolean;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.FormEvent<HTMLInputElement>) => void;
  onClickIcon?: () => void;
  onFocusInput?: () => void;
}

export default TextInput;
